import React from 'react';
import './styles/MobileFooter.css';

const MobileFooter: React.FC = () => {
  return (
    <footer className="mobile-footer">
      <div className="footer-content">
        <h2 className="footer-title">Materials to Services</h2>
        <h2 className="footer-subtitle">In Minutes</h2>
        
        <div className="footer-logo">
          <img 
            src="/images/logo-nobg.png" 
            alt="Build Zap Logo" 
            className="logo-image"
          />
        </div>

        <p className="footer-copyright">
          BuildZap is owned and operated by BSC INNOVATIONS PVT LTD
        </p>
      </div>
    </footer>
  );
};

export default MobileFooter;